<template>
  <v-dialog
    v-model="dialog"
    :fullscreen="$vuetify.breakpoint.xs"
    persistent
    scrollable
    :max-width="`${width}px`"
  >
    <v-card>
      <v-toolbar dark color="primary">
        <v-btn icon flat @click="$emit('cancel')">
          <v-icon>arrow_back</v-icon>
        </v-btn>
        <v-toolbar-title>{{ titleDialog }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon :dark="!sameInput" :disabled="sameInput" @click="submit">
          <v-icon>save</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text style="height: 1000px">
        <v-form>
          <v-text-field
            v-if="dialog"
            autofocus
            append-icon="map"
            type="text"
            v-model="input.area"
            v-validate="'required'"
            name="area"
            data-vv-name="area"
            label="Nama Area"
            data-vv-as="Nama Area"
            :error-messages="errors.collect('area')"
          >
          </v-text-field>
          <v-select
            append-icon="local_offer"
            attach
            item-text="laman"
            item-value="id_laman"
            :items="lamanByLaman"
            v-model="input.id_laman"
            v-validate="'required'"
            name="id_laman"
            data-vv-name="id_laman"
            label="Business Unit"
            data-vv-as="Business Unit"
            :error-messages="errors.collect('id_laman')"
          >
            <template slot="item" slot-scope="data">
              <v-list-tile-content>
                <v-list-tile-title>{{ data.item.laman }}</v-list-tile-title>
                <v-list-tile-sub-title>{{
                  data.item.laman_desc
                }}</v-list-tile-sub-title>
              </v-list-tile-content>
            </template>
          </v-select>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>


<script>
import _ from "lodash";
import { mapState, mapGetters } from "vuex";

const defaultInput = {
  area: "",
  id_laman: ""
};

export default {
  name: "client-area-input",
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: null
    },
    action: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    primary_key: {
      type: String,
      default: ""
    },
    primary_field: {
      type: String,
      default: ""
    },
    width: {
      type: Number,
      default: 500
    }
  },
  data() {
    return {
      input: _.cloneDeep(defaultInput),
      dataInjected: null
    };
  },
  computed: {
    ...mapState(["status", "id_laman$"]),
    ...mapGetters("laman", ["lamanByLaman"]),
    source() {
      return this.$store.state[this.primary_field][this.primary_field];
    },
    titleDialog() {
      let title = this.action == "ADD" ? "TAMBAH" : "EDIT";
      return `${title} ${this.title}`;
    },
    sameInput() {
      return _.isEqual(this.input, this.dataInjected);
    }
  },
  methods: {
    submit() {
      this.$validator.validateAll().then(noError => {
        if (noError) {
          this.$store
            .dispatch(
              `${this.primary_field}/${this.action}_${this.title}`,
              this.input
            )
            .then(() => {
              let new_id =
                this.action == "ADD"
                  ? _.last(this.source)[this.primary_key]
                  : null;
              this.$emit("submitted", new_id);
            })
            .catch();
        } else {
          this.$store.commit(
            "ERROR",
            "Ada field yang masih error, cek kembali isian form!"
          );
        }
      });
    }
  },
  watch: {
    dialog(val) {
      if (val) {
        this.$validator.reset();
        if (this.action == "ADD") {
          this.dataInjected = _.cloneDeep(defaultInput);
          this.dataInjected.id_laman = this.id_laman$;
        } else {
          this.dataInjected = _.cloneDeep(this.data);
        }
        this.input = _.cloneDeep(this.dataInjected);
      }
    }
  },
  mounted() {
    this.$store.dispatch("area/GET_AREA");
    this.$store.dispatch("area/GET_OPTIONS");
  }
};
</script>
